import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Price, DEFAULT_PRICE_OBJECT } from '@model/common';
import { Included } from '@model/tours';
import { TourActions } from '@state/slices/tours/tourActions';

export interface TourSummaryState {
  destinationName: string;
  tourDescription: string;
  tourImage: string;
  tourName: string;
  connectId: string;
  tourPrice: Price;
  whatsIncluded: Array<Included> | null;
}

export const INITIAL_TOUR_SUMMARY_STATE: TourSummaryState = {
  destinationName: '',
  tourDescription: '',
  tourImage: '',
  tourName: '',
  connectId: '',
  tourPrice: {
    ...DEFAULT_PRICE_OBJECT,
    amount: 0
  },
  whatsIncluded: null
};

const tourSummarySlice = createSlice({
  name: TourActions.SLICE_NAME,
  initialState: INITIAL_TOUR_SUMMARY_STATE,
  reducers: {
    setTourSummary: (_state, action: PayloadAction<TourSummaryState>) => {
      return action.payload;
    },
    unsetTourSummary: () => {
      return INITIAL_TOUR_SUMMARY_STATE;
    }
  }
});

export const { setTourSummary, unsetTourSummary } = tourSummarySlice.actions;

export const tourSummaryReducer = tourSummarySlice.reducer;
